import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "./common";
import { IpSet } from "../../schema/types/ipset/entity";

export const ipSetApi = createApi({
  reducerPath: "ipSetApi",
  baseQuery: customBaseQuery,
  tagTypes: ["IpSet"],
  endpoints: (builder) => ({
    getIpSet: builder.query<IpSet, string>({
      queryFn: async (link) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({ url: link });
          return { data };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: (result, error, link) => [{ type: "IpSet", id: link }],
    }),
  }),
});

export const { useGetIpSetQuery } = ipSetApi;
